import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatPrice',
  standalone: true,
})
export class FormatPricePipe implements PipeTransform {
  constructor(private currencyPipe: CurrencyPipe) {}

  public transform(
    value: number | string,
    currency?: string,
    display?: string | boolean,
    digitsInfo?: string,
  ) {
    const priceWithCurrency =
      typeof value === 'string'
        ? `${currency}${value}`
        : this.currencyPipe.transform(value, currency, display, digitsInfo);

    return priceWithCurrency?.replace(/([a-z]+)(?=\d)/gi, '$1 ');
  }
}
